import { render, staticRenderFns } from "./PrincipalGroupBindings.vue?vue&type=template&id=13fa38d1&scoped=true&"
import script from "./PrincipalGroupBindings.vue?vue&type=script&lang=js&"
export * from "./PrincipalGroupBindings.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalGroupBindings.vue?vue&type=style&index=0&id=13fa38d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa38d1",
  null
  
)

export default component.exports